import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Components/App';
import './Styles/index.css';
import './Styles/handsontable.css';
import reportWebVitals from './reportWebVitals';
import defaultTheme from './Components/StoneXMui/default-theme';
import { ThemeProvider } from '@mui/material';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={defaultTheme}>
    <App />
  </ThemeProvider>
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
